module.exports = __webpack_public_path__ + "assets/5b74009792d7cc6b09ea7d8c5205ca15.png";